import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2313f995")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "disclaimers",
    style: {'padding': _ctx.padding}
  }, " 免责声明：本报告内容仅作为健康评估建议，在决定医疗方案之前，请咨询医生。 ", 4))
})